import React, { memo, useCallback } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import LazyLoad from "react-lazyload";
import "./PaymentSuccess.scss";

const PaymentFailure = () => {
  const navigate = useNavigate();
  const { id: classroomId } = useParams();
  const [searchParams] = useSearchParams();
  const selectedSubscription = localStorage.getItem("selectedSubscription");

  // Extract responseMessage from URL query parameters
  const responseMessage = searchParams.get("responseMessage");

  // Decode the URL-encoded message
  const decodedMessage = responseMessage
    ? decodeURIComponent(responseMessage)
    : null;

  const handleRetryPayment = useCallback(() => {
    navigate(
      `/student/myClassrooms/${classroomId}/payment-form?subscriptionId=${selectedSubscription}`
    ); // Adjust this route as per your application
  }, [classroomId, navigate, selectedSubscription]);

  return (
    <div className="payment-status-page payment-failure">
      <div className="failure-icon-container">
        <div className="failure-icon">
          <svg
            width="80"
            height="80"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="10" stroke="#dc3545" strokeWidth="2" />
            <path
              d="M15 9L9 15M9 9L15 15"
              stroke="#dc3545"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>

      <h1 className="failure-title mb-4">Payment Failed</h1>

      <div className="failure-message">
        <p>
          {decodedMessage ||
            "Unfortunately, your transaction could not be completed."}
        </p>
      </div>

      <div className="failure-actions">
        <Button
          className="retry-button"
          onClick={handleRetryPayment}
          variant="danger"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginRight: "8px" }}
          >
            <path
              d="M1 4V10H7"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.51 15A9 9 0 1 0 6 5L1 10"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Retry Payment
        </Button>
      </div>

      <div className="failure-help">
        <p className="help-text">
          Need help? Contact our support team for assistance.
        </p>
      </div>
    </div>
  );
};

export default memo(PaymentFailure);
